/*
	This is a reducer that ONLY HOUSES ANALYTICS calls.
	It contains no internal state.
	It only subscribes to the actions in the signup ducks file,
	and composes the state to
*/
import Analytics from "./util/Analytics";
import CUSTOM_EVENT_TYPES from "./util/CustomEventTypes";

import {
	VOTE_COMPLETE,
} from "ducks/quickmatch";

import { prepUserData } from "apps/quickmatch/util/helpers";
import { getValueForPromoDesign } from "analytics/util/queryParamsMap";

// ////////////////////////
// REDUCER ///////////////
// //////////////////////

function trackCardShown(match, cardType) {
	const userData = prepUserData(match);
	const {
		userid,
		percentages = {},
		likes = {},
		last_contacts: lastContacts,
	} = userData;

	return Analytics.logUIEvent(Analytics.eventNames.cardShown, {
		data: {
			"card type": cardType || "user",
			"content id": userid,
			"match percent": percentages.match,
			"likes you card": !!(likes && likes.they_like),
			"boosted like": likes && !!likes.via_spotlight ? "yes" : "no",
			"message flag": lastContacts && !!lastContacts.reverse ? "yes" : "no",
		},
	});
}

function trackVoted(match, liked, inputMethod) {
	const userData = prepUserData(match);
	const {
		userid,
		percentages = {},
		likes = {},
		last_contacts: lastContacts,
	} = userData;

	return Analytics.logUIEvent(Analytics.eventNames.voted, {
		type: CUSTOM_EVENT_TYPES.user_content,
		data: {
			"vote value": liked ? "yes" : "no",
			"card type": "user",
			"content id": userid,
			"match percent": percentages.match,
			"resulted in mutual like": !!likes && likes.they_like && liked ? "yes" : "no",
			"boosted like": !!likes && !!likes.via_spotlight ? "yes" : "no",
			"message flag": lastContacts && !!lastContacts.reverse ? "yes" : "no",
			"vote method": inputMethod,
		},
	});
}

export default function quickmatch(state, action) {
	switch (action.type) {
		case VOTE_COMPLETE: {
			if (action.likesRemaining === 0) {
				if (action.shouldTrackHitLikesCap) {
					Analytics.logUIEvent(Analytics.eventNames.reachedDailyLikes);

					// early exit
					return;
				} else {
					Analytics.logUIEvent(Analytics.eventNames.votedAfterLikesCapLimit, {
						data: {
							"promo id": "alist.likescappaywall",
							"promo design": getValueForPromoDesign("profilephoto"),
							"target user id": action.targetUserId,
							"vote value": action.liked ? "like" : "pass",
							source: "doubletake",
						},
					});
					return;
				}
			}

			const queue = state.stacks[state.activeStackId].data.length
				? state.stacks[state.activeStackId].data
				: action.matches;

			if (!queue || !queue.length) {
				return;
			}

			const [ match ] = queue;

			trackCardShown(match, match.cardType);
			trackVoted(match, action.liked, action.inputMethod);

			return;
		}

		default: {
			return;
		}
	}
}



// WEBPACK FOOTER //
// ./src/analytics/quickmatch.js